export default __webpack_public_path__ + "6ca608d6d4c47094116ead88a4e0f72d.png";